import Vue from 'vue'
// import '@/plugins/axios'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/vant.js'
import 'lib-flexible/flexible'


import weconfig from "@/libs/config"
import webrowser from  "@/libs/browser"
import weapi from  "@/libs/api.request"
import weutil from  "@/libs/util"
import werouter from  "@/router/routerConfig"
Vue.prototype.weconfig = weconfig;
Vue.prototype.browser = webrowser;
Vue.prototype.weapi = weapi;
Vue.prototype.weutil = weutil;
Vue.prototype.westore = store;
Vue.prototype.werouter = werouter;
Vue.prototype.eventbus = new Vue();
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
